<template lang="pug">
section.ficha-tecnica-panel(:class="'color_' + removeHashtag(color)" v-show="fichaTecnica" ref="component")
  .layout.row.title
    .flex.xs12.asu-title(:style="getBackgroundColorPropertyStyle(color)") Ficha Técnica
  .layout.row
    .flex.xs4.ubicacion.key(:style="getBackgroundColorPropertyStyle(color)") Ubicación
    .flex.xs8.ubicacion.value(v-html="fichaTecnica.ubicacion")
  .layout.row
    .flex.xs4.superficie.key(:style="getBackgroundColorPropertyStyle(color)") Longitud-Superficie
    .flex.xs8.superficie.value(v-html="fichaTecnica.superficie")
  .layout.row
    .flex.xs4.fuenteFinanciacion.key(:style="getBackgroundColorPropertyStyle(color)") Fuentes de Financiación
    .flex.xs8.fuenteFinanciacion.value(v-html="fichaTecnica.fuenteFinanciacion")
  .layout.row
    .flex.xs4.costoEstimativo.key(:style="getBackgroundColorPropertyStyle(color)") Costo estimativo
    .flex.xs8.costoEstimativo.value
      div(v-if="!isSubproject") {{costo.toString().toLocaleString('es')}} {{fichaTecnica.costoMoneda ? fichaTecnica.costoMoneda : 'US$'}}
      div.descripcion-costo(:class="{'mt-2': !isSubproject}" v-if="fichaTecnica.costoEstimativo" v-html="`${fichaTecnica.costoEstimativo}`")
  .layout.row
    .flex.xs4.enteEjecutor.key(:style="getBackgroundColorPropertyStyle(color)") Ente Ejecutor
    .flex.xs8.enteEjecutor.value(v-html="getEnteEjecutor()")
  .layout.row
    .flex.xs4.estado.key(:style="getBackgroundColorPropertyStyle(color)") Estado
    .flex.xs8.estado.value(v-html="fichaTecnica.estado")
  .layout.row
    .flex.xs4.tipo.key(:style="getBackgroundColorPropertyStyle(color)") Tipo de proyecto
    .flex.xs8.tipo.value(v-html="fichaTecnica.tipo")
  .layout.row
    .flex.xs4.familias.key(:style="getBackgroundColorPropertyStyle(color)") Familias
    .flex.xs8.familias.value(v-html="fichaTecnica.familias")
  <!--.layout.row-->
    <!--.flex.xs4.beneficiarios.key(:style="getBackgroundColorPropertyStyle(color)") Beneficiarios-->
    <!--.flex.xs8.beneficiarios.value(v-html="fichaTecnica.beneficiarios")-->

</template>

<script>
import { addRules } from '@/utils/add-styles-in-header.js'
import colorPropertyMixin from '@/mixins/color-property.js'

export default {
  name: 'FichaTecnicaPanel',
  mixins: [colorPropertyMixin],
  props: {
    color: String,
    costo: {
      type: [String, Number],
      default: ''
    },
    fichaTecnica: Object,
    isSubproject: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.addRulesForFichaTecnicaKey()
  },
  methods: {
    addRulesForFichaTecnicaKey () {
      const color = this.removeHashtag(this.color)
      const scope = this.getScopeName()
      const scopeSelector = scope ? '[' + scope + ']' : ''
      addRules('.color_' + color + ' .ficha-tecnica-panel .key' + scopeSelector + ':after', { 'border-left-color': this.color + '!important' })
    },
    getEnteEjecutor () {
      return this.fichaTecnica && this.fichaTecnica.enteEjecutor && this.fichaTecnica.enteEjecutor.join(' - ')
    }
  },
  watch: {
    color (newValue, oldValue) {
      this.addRulesForFichaTecnicaKey()
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$key-arrow-size = $f6px
$ficha-tecnica-border-radius-size = $f5px

.ficha-tecnica-panel
  column-gap: 0
  line-height: 1
  .layout.row
    padding-bottom: $f4px
    padding-top: $f4px
    &.title
      padding-top: 0
  .asu-title,
  .key,
  .value
    display: flex
    align-items: center
    padding: $f10px
    white-space: normal
  .asu-title,
  .key
    color: white
  .key
    border-top-left-radius: $ficha-tecnica-border-radius-size
    border-bottom-left-radius: $ficha-tecnica-border-radius-size
    position: relative
    &:after
      content: ''
      display: inline-block
      height: 0
      width: 0
      border: $key-arrow-size outset transparent
      border-left-width: $key-arrow-size
      border-left-style: solid
      position: absolute
      left: 100%
  .asu-title
    border-radius: $ficha-tecnica-border-radius-size
    font-size: 1.3rem
    font-weight: bold
  .value
    background-color: white
    border: $f1px solid #bbb
    border-top-right-radius: $ficha-tecnica-border-radius-size
    border-bottom-right-radius: $ficha-tecnica-border-radius-size
    white-space: pre-line
  .costoEstimativo.value
    display: block
    .descripcion-costo
      font-size: $f16px
      font-style: italic

</style>
